/**
 * Viewport queries for the mobile-web layout. Compact modes are CSS media
 * queries (not a user-agent check). Desktop windows stay unchanged unless
 * the window itself is phone-sized.
 *
 * Keep CSS @media in views in sync with these strings.
 */
export const DUEL_COMPACT_MQ = '(max-height: 500px) and (max-width: 1100px)'
/**
 * Small laptop window (1280×768, 1366×768). Taller than phone landscape,
 * so the duel keeps the desktop rail, with shorter buttons.
 */
export const DUEL_SNUG_MQ = '(max-width: 1440px)'
export const DUEL_ROTATE_MQ = '(max-width: 700px) and (orientation: portrait)'
/** Portrait phone (narrow). */
export const MENUS_NARROW_MQ = '(max-width: 720px)'
/** Standing phone. Pack opening uses this for the binder stow, not the case. */
export const MENUS_PORTRAIT_MQ = '(max-width: 720px) and (orientation: portrait)'
/** Landscape phone / short window. Same shape as duel compact. */
export const MENUS_SHORT_MQ = DUEL_COMPACT_MQ
/** Either a narrow portrait phone or a short landscape window. */
export const MENUS_COMPACT_MQ = `${MENUS_NARROW_MQ}, ${MENUS_SHORT_MQ}`

export function mqMatches(query: string): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(query).matches
}

/** True while the duel chrome should collapse (rail, nav, TurnInfo). */
export function isDuelCompactNow(): boolean {
  return mqMatches(DUEL_COMPACT_MQ)
}

/**
 * Own face-down cards pulse so a finger can tell Sets apart.
 * Landscape phones match {@link DUEL_COMPACT_MQ}. Tablets are taller than
 * that query; a coarse pointer, or no hover, gets the same pulse. Some
 * Android tablets still advertise a fake mouse, so a touch screen inside a
 * tablet-sized window counts too. A mouse on a desktop does not.
 */
export function needsOwnSetPeekNow(): boolean {
  if (isDuelCompactNow()) return true
  if (typeof window === 'undefined') return false
  if (mqMatches('(hover: none)') || mqMatches('(pointer: coarse)')) return true
  const touch = typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0
  if (!touch) return false
  return mqMatches('(max-width: 1400px) and (max-height: 1400px)')
}

export function isDuelSnugNow(): boolean {
  return mqMatches(DUEL_SNUG_MQ)
}

export function needsDuelRotateNow(): boolean {
  return mqMatches(DUEL_ROTATE_MQ)
}

export function isMenusShortNow(): boolean {
  return mqMatches(MENUS_SHORT_MQ)
}

export function isMenusNarrowNow(): boolean {
  return mqMatches(MENUS_NARROW_MQ)
}

export function isMenusPortraitNow(): boolean {
  return mqMatches(MENUS_PORTRAIT_MQ)
}

export function isMenusCompactNow(): boolean {
  return mqMatches(MENUS_NARROW_MQ) || mqMatches(MENUS_SHORT_MQ)
}
